var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterClean(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.309 4.207a.5.5 0 00.084.702L3.75 6.757c.023.035.048.07.076.103l5.084 6.195v2.194c0 .306.11.556.333.723l1.778 1.333a.959.959 0 00.945.084.866.866 0 00.5-.806v-2.99l4.664 3.659a.5.5 0 00.702-.085l.432-.551a.5.5 0 00-.084-.702L2.443 3.57a.5.5 0 00-.702.085l-.432.55zM17.522 6.86L14.5 10.563 7.44 5.026h9.249c.416 0 .805.25 1 .639.166.389.11.861-.167 1.195z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterClean);
export default ForwardRef;